import { DownloadSimple } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { Variant } from 'theme/enums';

// The exported columns read as the grid shows them: the type label and the values' labels.
const DOWNLOADED_COLUMN_IDS = ['name', 'type', 'values'];

// The selected lists as a CSV file, built from the grid itself.
export const DownloadPartFinderAttributesButton = () => {
  const { t } = useTranslation();

  const { gridApi } = useAgGridClientTableContext();

  const onDownload = () =>
    gridApi?.exportDataAsCsv({
      onlySelected: true,
      columnKeys: DOWNLOADED_COLUMN_IDS,
      fileName: `${t('titlePartFinderAttributes')}.csv`,
    });

  return (
    <Button
      text={t('buttonLabelDownload')}
      variant={Variant.SOFT}
      startDecorator={<DownloadSimple />}
      onClick={onDownload}
    />
  );
};
